import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import InSetBoxShadow from "../../../Common/InSetBoxShadow";
import { useCard } from "../Hooks";
import { DateInput } from "react-hichestan-datetimepicker";

const Partner = () => {
  const { user, basket } = useSelector(state => state);
  const { handleChange } = useCard();
  return (
    <>
      <div className="row partner-step">
        {basket.otherpeopel &&
          [...basket.otherpeopel].map((people, i) => {
            return (
              <div className="col-12 mb-3" key={i}>
                <InSetBoxShadow className={"py-4 px-3"}>
                  <div className="row">
                    <div className="form-group col-md-4 mb-3">
                      <label htmlFor="inputEmail4">نام و نام خانوادگی</label>
                      <input
                        style={{
                          color: "#717171",
                        }}
                        type="text"
                        className="form-control"
                        name="fullname"
                        onChange={handleChange}
                        id={people.id}
                        defaultValue={people.fullname}
                        disabled={people.fullname && people.self}
                      />
                    </div>
                    <div className="form-group col-md-4 mb-3">
                      <label htmlFor="inputPassword4">کد ملی</label>
                      <input
                        style={{
                          color: "#717171",
                        }}
                        type="number"
                        className="form-control"
                        name="national_code"
                        onChange={handleChange}
                        id={people.id}
                        defaultValue={people.national_code}
                        disabled={
                          people.national_code &&
                          people.national_code.length == 10 &&
                          people.self
                        }
                      />
                    </div>

                    <div className="form-group col-md-4 mb-3">
                      <label
                        htmlFor="inputPassword4"
                        style={{
                          color: "#717171",
                        }}
                      >
                        شماره تماس
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        id={people.id}
                        onChange={handleChange}
                        name="mobile"
                        defaultValue={people.mobile}
                        disabled={people.mobile && people.self}
                      />
                    </div>
                  </div>
                </InSetBoxShadow>
              </div>
            );
          })}
      </div>
      <div className="row mb-3">
        <div className="col-12">
          <InSetBoxShadow className={"px-2 px-sm-3 px-md-4 py-4"}>
            <div className="d-flex alert-box">
              <img
                src={window.origin + `/WebSide/assets/images/danger.png`}
                alt="همه ملاقات"
                style={{
                  width: "20px",
                  height: "20px",
                  marginLeft: "8px",
                }}
              />
              <p
                style={{
                  color: "#717171",
                }}
              >
                لطفا در پر کردن اطلاعات هویتی دقت لازم را انجام دهید
              </p>
            </div>
          </InSetBoxShadow>
        </div>
      </div>
      <div className="row ">
        <div className="col-12">
          <InSetBoxShadow className={"px-2 px-sm-3 px-md-4 py-4"}>
            <div className="d-flex alert-box">
              <img
                src={window.origin + `/WebSide/assets/images/danger.png`}
                alt="همه ملاقات"
                style={{
                  width: "20px",
                  height: "20px",
                  marginLeft: "8px",
                }}
              />
              <p
                style={{
                  color: "#717171",
                }}
              >
                بعد از پرداخت و دریافت بلیت ،{" "}
                <span style={{ color: "#e42a3f" }}>کدپیگیری</span> برا شما صادر
                خواهد شد ،‌ لطفا کد را به خاطر بسپارید
              </p>
            </div>
          </InSetBoxShadow>
        </div>
      </div>
    </>
  );
};

export default Partner;
